import { AfterViewInit, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LayoutState } from './layout/layout.state';
import { AsyncPipe, NgIf } from '@angular/common';
import { MaterialLoaderComponent } from './shared/component/material-loader/material-loader.component';
import { distinctUntilChanged } from 'rxjs';

@Component({
  selector: 'eap-root',
  standalone: true,
  imports: [RouterOutlet, MaterialLoaderComponent, NgIf, AsyncPipe],
  template: `<router-outlet></router-outlet> <eap-material-loader *ngIf="loading$ | async"></eap-material-loader>`
})
export class AppComponent implements AfterViewInit {
  title = 'EAPAngular';
  
  public layoutState = inject(LayoutState);
  public loading$ = this.layoutState.isLoading$.pipe(distinctUntilChanged());
  
  ngAfterViewInit(): void {
    this.loading$ = this.layoutState.isLoading$.pipe(distinctUntilChanged());
  }
}